import {
    baseURL,
    contentType,
    debounce,
    messageName,
    requestTimeout,
    statusName,
    successCode,
    /* tokenName, */
} from '@/config'
import router from '@/router'

let loadingInstance

let refreshToking = false

let requests = []

/**
 * axios请求拦截器配置
 * @param config
 * @returns {any}
 */
const requestConf = (config) => {
    if (
        config.data &&
        config.headers['Content-Type'] ===
        'application/x-www-form-urlencoded;charset=UTF-8'
    )

        config.data = qs.stringify(config.data)
    return config
}


/**
 * axios响应拦截器
 * @param config 请求配置
 * @param data response数据
 * @param status HTTP status
 * @param statusText HTTP status text
 * @returns {Promise<*|*>}
 */
const handleData = async ({config, data, status, statusText}) => {
    if (loadingInstance) loadingInstance.close()
    // 若data.code存在，覆盖默认code
    let code = data && data[statusName] ? data[statusName] : status
    // 若code属于操作正常code，则status修改为200
    switch (code) {
        case 200:
            // 业务层级错误处理，以下是假定restful有一套统一输出格式(指不管成功与否都有相应的数据格式)情况下进行处理
            // 例如响应内容：
            // 错误内容：{ code: 1, msg: '非法参数' }
            // 正确内容：{ code: 200, data: {  }, msg: '操作正常' }
            // return data

            if (config.hideError) {

            } else if (!data.success) {
                vant.Toast(data.message);
                // Vue.prototype.$baseMessage(data.message, "error", false, "vab-hey-message-error");
                const err = new Error(data.message);
                // if (checkNeed())
                //   store
                //     .dispatch("errorLog/addErrorLog", {
                //       err,
                //       url: config.url
                //     })
                //     .then(() => {
                //     });
                return Promise.reject(err);
            }

            return data
        case 401:
            store
                .dispatch('user/resetAll')
                .then(() =>
                    router.push({path: '/login', replace: true}).then(() => {
                    })
                )
            break
        case 402:
            return await tryRefreshToken(config)
        case 403:
            router.push({path: '/403'}).then(() => {
            })
            break
    }
    // 异常处理
    // 若data.msg存在，覆盖默认提醒消息
    const errMsg = `${config.url} 后端接口 ${code} 异常：${
        data && data[messageName]
            ? data[messageName]
            : CODE_MESSAGE[code]
                ? CODE_MESSAGE[code]
                : statusText
    }`
    vant.Toast(data.errMsg);

    // Vue.prototype.$baseMessage(errMsg, 'error', 'vab-hey-message-error')
    const err = new Error(errMsg)

    return Promise.reject(err)
}

/**
 * @description axios初始化
 */
const instance = axios.create({
    baseURL,
    timeout: requestTimeout,
    headers: {
        'Content-Type': contentType,
    },
})

/**
 * @description axios请求拦截器
 */
instance.interceptors.request.use(requestConf, (error) => {
    return Promise.reject(error)
})

/**
 * @description axios响应拦截器
 */
instance.interceptors.response.use(
    (response) => handleData(response),
    (error) => {
        const {response} = error
        if (response === undefined) {
            vant.Toast(
                '网络错误，请检查网络是否连接成功'
            )
            return {}
        } else return handleData(response)
    }
)

export default instance
